/**
 * @generated SignedSource<<b01c0c60571c6f7d8c7b084669bf5414>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginActivateEmailQuery$variables = {
  key: string;
};
export type LoginActivateEmailQuery$data = {
  readonly loginActivation: {
    readonly email: string | null | undefined;
  } | null | undefined;
};
export type LoginActivateEmailQuery = {
  response: LoginActivateEmailQuery$data;
  variables: LoginActivateEmailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "key"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginActivateEmailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LoginActivateEmailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "LoginActivation",
        "kind": "LinkedField",
        "name": "loginActivation",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83c08ab642704f7bbe4ee3cf16eb5353",
    "id": null,
    "metadata": {},
    "name": "LoginActivateEmailQuery",
    "operationKind": "query",
    "text": "query LoginActivateEmailQuery(\n  $key: String!\n) {\n  loginActivation(key: $key) {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d4038ed9d44f01a9dd6669cc7287f10";

export default node;
